import { Descriptor } from "./Descriptor"

export class State extends Descriptor {}
